import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import localforage from "localforage";
import { createStore } from "polotno/model/store";
import Home from "../pages/home";
import Profile from "../pages/profile";
import Topbar from "../components/topbar"
import updateSubscription from "../pages/updateSubscription";
const store = createStore({ key: "OUzdh376cQCsP5r8Rm8M", showCredit: false});
window.store = store;

localforage.getItem("polotno-state", function (err, json) {
  if (json) {
    store.loadJSON(json);
  }
  if (!store.pages.length) {
    store.addPage();
  }
});

store.on("change", () => {
  try {
    const json = store.toJSON();
    localforage.setItem("polotno-state", json);
  } catch (e) {}
});

export default function PrivateRoutes(props) {
  return (
    <>
      <Topbar store={store} currentUser={props.currentUser} show={window.location.href === `${window.location.origin}/`}/>
      {window.location.href === `${window.location.origin}/` ? (
        <Home store={store} />
      ) : (
        <Routes />
      )}
    </>
  );
}

function Routes() {
  return (
    <Router>
      <Switch>
        <Route
          render={() => {
            window.location.replace("/");
          }}
        />
      </Switch>
    </Router>
  );
}
